import { Flex, Text, Icon } from 'roo-ui/components';

interface LabelProps {
  iconName: string;
  heading: string;
  message: string;
}

export const Label = ({ iconName, heading, message }: LabelProps) => {
  const lines = message.split('\n');

  return (
    <Flex flexDirection="row">
      <Icon size={24} mr={3} name={iconName} color="green" />
      <Flex flexDirection="column">
        <Text fontSize={16} mb={1} textDecoration="underline" color="green">
          {heading}
        </Text>
        {lines.map((line, index) => (
          <Text fontSize={14} key={`label-${index}`}>
            {line}
          </Text>
        ))}
      </Flex>
    </Flex>
  );
};
